import { language } from "index";
import { EnvironmentVariables } from 'models/environment';
import env from 'modules/env/env';

//returns true if the language matches any country code in the countryCodes array, otherwise it returns false
export const runBasedOnCoutries = (countryCodes: string[]) => {
  if (countryCodes.includes(language as string)) return true;
  return false;
};

// navigate to sso
export const redirectToLogin = () => {
  const ssoUrl = env(EnvironmentVariables.ssoHost);
  const clientId = 'client_id=' + env(EnvironmentVariables.clientId);
  const redirectUrl = 'redirect_url=' + encodeURIComponent(env(EnvironmentVariables.host) + 'delete');
  const url = ssoUrl + '#/?' + clientId + '&' + redirectUrl;
  window.location.href = url;
};
